module.exports = __webpack_public_path__ + "img/chevron-right-solid-colortext1.af537145.svg";